import React, { useState } from 'react';
import { Helmet } from "react-helmet";
import { Link } from '../hooks/router';

import './guest.scss';

export default function GuestLayout({ children }) {
  const [openMenu, setOpenMenu] = useState(false);
  return (
    <>
      <Helmet>
        <title>Wiltee</title>
        <meta name="description" content="" />
      </Helmet>
      <div className="guest-layout">
        <header>
          <div className="menu">
              <div className="logo">
                <a href="https://wiltee.com">
                  <img src="https://wiltee.com/assets/home/logo.png" alt="" />
                </a>
              </div>
              <i className="fas fa-bars" onClick={() => setOpenMenu(prevOpenMenu => !prevOpenMenu)} />
              <div className={`sub${openMenu ? ' open-menu' : ''}`}>
                <div className="links">
                  <a href="https://wiltee.com/wiltee-catalogueprices-juillet2020.pdf">Catalogue et Tarifs</a>
                  <a href="https://wiltee.com/how">Comment ça marche</a>
                  <Link to="faq">FAQ</Link>
                  <a href="https://wiltee.com/blog">Blog</a>
                </div>
                <div className="separator" />
                <div className="actions">
                  <a href="https://wiltee.com/connection">Se connecter</a>
                  <a href="https://wiltee.com/register">S'inscrire</a>
                </div>
              </div>
          </div>
        </header>
        <div className="corp">
          {children}
        </div>
        <footer>
          <div className="col">
            <a href="/register">S'inscrire</a>
            <a href="/connexion">Se connecter</a>
            <a href="/how">Comment ça marche ?</a>
            <a href="/wiltee-catalogueprices-juillet2020.pdf">Catalogue et Tarifs</a>
            <a href="/blog">Blog</a>
            <a href="/faq">FAQ</a>
            <span>
                Pour toute demande commerciale : <a href="mailto:bruno@wiltee.com">bruno@wiltee.com</a>
            </span>
            <span>
                Pour toute demande liée à une commande en cours : <a href="mailto:sav@wiltee.com">sav@wiltee.com</a>
            </span>
          </div>
          <div className="col">
            <a href="/cgu">Conditions Générales d’Utilisation</a>
            <a href="/cgv">Conditions Générales de Vente</a>
          </div>
        </footer>
      </div>
    </>
  );
};